import { Theme } from '@mui/material';
import { FC, memo, ReactNode } from 'react';
import { makeStyles } from 'tss-react/mui';
import Panel from '../../elements/Panel/Panel';
import ExecutiveSummaryPanel from './ExecutiveSummaryPanel';

const ExecutiveSummaryLayout: FC<
  React.PropsWithChildren<ExecutiveSummaryLayoutProps>
> = ({ topBar, headerLeft1, headerLeft2, headerRight, main, footer }) => {
  const { classes } = useStyles();
  return (
    <div className={classes.executiveSummaryLayout}>
      <Panel height='100%' className={classes.topBar}>
        {topBar}
      </Panel>
      <div className={classes.headerLeft1}>
        <ExecutiveSummaryPanel>{headerLeft1}</ExecutiveSummaryPanel>
      </div>
      <div className={classes.headerLeft2}>
        <ExecutiveSummaryPanel>{headerLeft2}</ExecutiveSummaryPanel>
      </div>
      <div className={classes.headerRight}>
        <ExecutiveSummaryPanel>{headerRight}</ExecutiveSummaryPanel>
      </div>
      <ExecutiveSummaryPanel className={classes.main}>
        {main}
      </ExecutiveSummaryPanel>
      <div className={classes.footer}>{footer}</div>
    </div>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  executiveSummaryLayout: {
    display: 'grid',
    gap: theme.spacing(2),
    gridTemplateColumns: '1fr 1fr 1fr',
    gridTemplateAreas: `
    "topBar topBar topBar"
    "headerLeft1 headerLeft1 headerLeft1"
    "headerLeft2 headerLeft2 headerLeft2"
    "headerRight headerRight headerRight"
    "main main main"
    "footer footer footer"
    `,
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      gridTemplateAreas: `
        "topBar topBar topBar"
        "headerLeft1 headerLeft2 headerRight" 
        "main main main"
        "footer footer footer"
      `,
    },
  },
  topBar: {
    gridArea: 'topBar',
    minHeight: 60,
  },
  headerLeft1: {
    gridArea: 'headerLeft1',
    minHeight: 160,
  },
  headerLeft2: {
    gridArea: 'headerLeft2',
    minHeight: 160,
  },
  headerRight: {
    gridArea: 'headerRight',
    minHeight: 160,
  },
  main: {
    gridArea: 'main',
    minHeight: 395,
  },
  footer: {
    gridArea: 'footer',
    minHeight: 446,
  },
}));

export interface ExecutiveSummaryLayoutProps {
  topBar: ReactNode;
  headerLeft1: ReactNode;
  headerLeft2: ReactNode;
  headerRight: ReactNode;
  main: ReactNode;
  footer: ReactNode;
}

export default memo(ExecutiveSummaryLayout);
